// Monitor scroll position and add .sticky-header to <body> when scrolled 45px or more
function handleScroll() {
  if (window.scrollY >= 40) {
    document.body.classList.add('sticky-header');
  } else {
    document.body.classList.remove('sticky-header');
  }
};
window.addEventListener('scroll', handleScroll);
window.addEventListener('DOMContentLoaded', handleScroll);




/* Navigation Keyboard Accessibility */
document.addEventListener('DOMContentLoaded', function () {
  const navOpener = document.querySelector('.nav-opener');
  const navHolder = document.querySelector('.nav-block__holder');
  const mainNavOpeners = document.querySelectorAll('.main-nav__opener');
  const overlay = document.querySelector('.overlay');

  // Debug: log which buttons are found
  console.log('Navigation init: found', mainNavOpeners.length, 'main nav opener buttons');
  mainNavOpeners.forEach((opener, i) => {
    const label = opener.getAttribute('aria-label');
    const controls = opener.getAttribute('aria-controls');
    const target = controls ? document.getElementById(controls) : null;
    console.log(`  [${i}]`, label, '→', controls, target ? `(found ${target.tagName}.${target.className})` : '(NOT FOUND)');
  });

  // Toggle mobile menu
  function toggleMobileMenu(open) {
    const isOpen = open ?? navHolder.getAttribute('aria-hidden') === 'true';
    navHolder.setAttribute('aria-hidden', !isOpen);
    navOpener.setAttribute('aria-expanded', isOpen);
    document.body.classList.toggle('nav-open', isOpen);
    
    if (isOpen) {
      // Focus first interactive element in menu
      const firstLink = navHolder.querySelector('a, button');
      if (firstLink) firstLink.focus();
    } else {
      // Return focus to opener
      navOpener.focus();
    }
  }

  // Toggle submenu/mega menu
  function toggleSubmenu(button, open) {
    const controlsId = button.getAttribute('aria-controls');
    const submenu = document.getElementById(controlsId);
    const isOpen = open ?? button.getAttribute('aria-expanded') === 'false';
    
    /*console.log('toggleSubmenu:', {
      label: button.getAttribute('aria-label'),
      controlsId,
      submenuFound: !!submenu,
      submenuTag: submenu?.tagName,
      submenuClass: submenu?.className,
      willOpen: isOpen
    });*/
    
    button.setAttribute('aria-expanded', isOpen);
    
    if (submenu) {
      submenu.setAttribute('aria-hidden', !isOpen);
      
      if (isOpen) {
        // Focus first link in submenu or mega menu
        const firstLink = submenu.querySelector('a');
       // console.log('  → focusing first link:', firstLink?.textContent?.trim());
        if (firstLink) setTimeout(() => firstLink.focus(), 100);
      }
    } else {
      //console.warn('  → submenu NOT FOUND for id:', controlsId);
    }
  }

  // Mobile menu opener click
  navOpener?.addEventListener('click', () => toggleMobileMenu());

  // Submenu opener clicks
  mainNavOpeners.forEach(opener => {
    opener.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      console.log('Click on:', opener.getAttribute('aria-label'));
      toggleSubmenu(opener);
    });
  });

  // Keyboard navigation
  document.addEventListener('keydown', (e) => {
    // Escape closes menus
    if (e.key === 'Escape') {
      // Close mobile menu if open
      if (navHolder.getAttribute('aria-hidden') === 'false') {
        toggleMobileMenu(false);
        return;
      }
      
      // Close any open submenu
      mainNavOpeners.forEach(opener => {
        if (opener.getAttribute('aria-expanded') === 'true') {
          toggleSubmenu(opener, false);
          opener.focus();
        }
      });
    }

    // Enter/Space on buttons
    if ((e.key === 'Enter' || e.key === ' ') && e.target.classList.contains('main-nav__opener')) {
      e.preventDefault();
      //console.log('Keyboard activate:', e.target.getAttribute('aria-label'));
      toggleSubmenu(e.target);
    }

    // Arrow key navigation in menus
    if (['ArrowDown', 'ArrowUp', 'ArrowLeft', 'ArrowRight'].includes(e.key)) {
      handleArrowKeys(e);
    }
  });

  // Arrow key navigation
  function handleArrowKeys(e) {
    const target = e.target;
    const isInSubmenu = target.closest('ul[id^="submenu-"], .mega');
    
    if (!isInSubmenu) return;

    const focusableElements = Array.from(
      isInSubmenu.querySelectorAll('a:not([disabled]), button:not([disabled])')
    );
    const currentIndex = focusableElements.indexOf(target);

    if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
      e.preventDefault();
      const nextIndex = (currentIndex + 1) % focusableElements.length;
      focusableElements[nextIndex]?.focus();
    }

    if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
      e.preventDefault();
      const prevIndex = currentIndex - 1 >= 0 ? currentIndex - 1 : focusableElements.length - 1;
      focusableElements[prevIndex]?.focus();
    }
  }

  // Focus trap in mobile menu
  function trapFocus(e) {
    if (navHolder.getAttribute('aria-hidden') === 'false') {
      const focusableElements = navHolder.querySelectorAll(
        'a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      const firstElement = focusableElements[0];
      const lastElement = focusableElements[focusableElements.length - 1];

      if (e.key === 'Tab') {
        if (e.shiftKey && document.activeElement === firstElement) {
          e.preventDefault();
          lastElement.focus();
        } else if (!e.shiftKey && document.activeElement === lastElement) {
          e.preventDefault();
          firstElement.focus();
        }
      }
    }
  }

  document.addEventListener('keydown', trapFocus);

  // Close menu when clicking overlay
  overlay?.addEventListener('click', () => toggleMobileMenu(false));

  // Close submenus when clicking outside
  document.addEventListener('click', (e) => {
    if (!e.target.closest('.main-nav')) {
      mainNavOpeners.forEach(opener => {
        if (opener.getAttribute('aria-expanded') === 'true') {
          toggleSubmenu(opener, false);
        }
      });
    }
  });
});




// Stats Callouts Count Up Animation
document.addEventListener('DOMContentLoaded', function () {
  

  // Parse a stat string (supports commas, currency prefix like $, ratios like 15:1)
  function parseStatDescriptor(raw) {
    const result = { end: 0, isPercent: false, prefix: '', suffix: '', decimals: 0 };
    if (!raw && raw !== 0) return result;
    let s = String(raw).trim();
    if (!s) return result;
    // detect percent
    if (s.indexOf('%') !== -1) {
      result.isPercent = true;
      s = s.replace('%', '').trim();
    }
    // detect prefix (currency like $)
    const prefixMatch = s.match(/^([^0-9\-\+\s]+)/);
    if (prefixMatch) {
      result.prefix = prefixMatch[1];
      s = s.slice(result.prefix.length).trim();
    }
    // detect ratio suffix like :1
    if (s.indexOf(':') !== -1) {
      const parts = s.split(':');
      s = parts[0].trim();
      result.suffix = ':' + parts.slice(1).join(':');
    }
    // find numeric part with optional commas and decimals
    const m = s.match(/-?\d{1,3}(?:,\d{3})*(?:\.\d+)?|-?\d+(?:\.\d+)?/);
    if (m) {
      let numStr = m[0].replace(/,/g, '');
      if (numStr.indexOf('.') !== -1) {
        result.decimals = numStr.split('.')[1].length;
      }
      const n = parseFloat(numStr);
      result.end = isNaN(n) ? 0 : n;
    }
    return result;
  }

  // Enhanced animateStat: supports prefix/suffix/decimals and preserves decorative <sup> elements
  function animateStat(el, end, duration, opts, cb) {
    opts = opts || {};
    const isPercent = !!opts.isPercent;
    const prefix = opts.prefix || '';
    const suffix = opts.suffix || '';
    const decimals = Math.max(0, Number(opts.decimals) || 0);
    const nfDuring = new Intl.NumberFormat(undefined, { maximumFractionDigits: 0 });
    const nfFinal = new Intl.NumberFormat(undefined, { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
    let startTime = null;

    // Preserve any decorative <sup used for stat suffixes (support both
    // legacy data-out-stats-attribute and new data-ouc-stats-super).
    let preservedSupHtml = '';
    try {
      const existingSup = el.querySelector && el.querySelector('sup[data-ouc-stats-super], sup[data-out-stats-attribute]');
      if (existingSup) preservedSupHtml = existingSup.outerHTML;
    } catch (e) {}
    // If it's a percent value and no explicit <sup> found, default to a plain % sup
    if (!preservedSupHtml && isPercent) preservedSupHtml = '<sup>%</sup>';

    function step(ts) {
      if (!startTime) startTime = ts;
      let progress = Math.min((ts - startTime) / duration, 1);
      // animate integer part during progress; show decimals at final state
      let current = Math.floor(progress * end);
      let display = nfDuring.format(current);
      if (isPercent) {
        el.innerHTML = String(display) + (suffix || '') + (preservedSupHtml || '');
      } else {
        // include prefix/suffix
        el.innerHTML = (prefix ? prefix : '') + display + (suffix ? suffix : '') + (preservedSupHtml || '');
      }
      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        // final state: show decimals if needed
        const finalNumber = isPercent ? String(Math.round(end)) : (prefix + nfFinal.format(end) + (suffix || ''));
        el.innerHTML = finalNumber + (preservedSupHtml || '');
        if (cb) cb();
      }
    }
    requestAnimationFrame(step);
  }

  const statEls = document.querySelectorAll('.stats-callout-number');
  const statDivs = document.querySelectorAll('.stats-callout');

  // Read inline final values as soon as possible and zero the displayed text.
  statEls.forEach((el) => {
    // Prefer explicit data attributes (data-ouc-stats-number or data-final-raw)
    // before falling back to the element's visible text. Many templates render
    // the human-visible number as a short or placeholder value (e.g. "7")
    // while the data attribute contains the full value ("7,618").
    const attrRaw = el.getAttribute('data-ouc-stats-number') || el.getAttribute('data-final-raw');
    const raw = (attrRaw != null && String(attrRaw).trim()) ? String(attrRaw).trim() : ((el.textContent || el.innerText || '').trim());
    // store raw final for debugging / fallback
    el.dataset.finalRaw = raw;
    // parse the descriptor to extract numeric value and formatting hints
    const parsed = parseStatDescriptor(raw);
    // Support new markup where the percent sign is provided in a sibling <sup data-ouc-stats-super>
    try {
      if (!parsed.isPercent && el.querySelector && el.querySelector('sup[data-ouc-stats-super]')) parsed.isPercent = true;
    } catch (e) {}
    el.dataset.final = String(parsed.end);
    if (parsed.isPercent) el.dataset.finalIsPercent = '1';
    if (parsed.prefix) el.dataset.finalPrefix = parsed.prefix;
    if (parsed.suffix) el.dataset.finalSuffix = parsed.suffix;
    if (parsed.decimals) el.dataset.finalDecimals = String(parsed.decimals);
    // zero out displayed value immediately (preserve prefix and any existing <sup> suffix)
    try {
      const existingSup = el.querySelector && el.querySelector('sup[data-ouc-stats-super], sup[data-out-stats-attribute]');
      const supHtml = existingSup ? existingSup.outerHTML : (parsed.isPercent ? '<sup>%</sup>' : '');
      el.innerHTML = (parsed.prefix || '') + '0' + (parsed.suffix || '') + (supHtml || '');
    } catch (e) {
      // fallback to safe textContent assignment
      if (parsed.isPercent) {
        el.innerHTML = '0<sup>%</sup>';
      } else {
        el.textContent = (parsed.prefix || '') + '0' + (parsed.suffix || '');
      }
    }
  });

  // Animate all stats in parallel
  function runStatsParallel() {
    statEls.forEach((el, idx) => {
      const parent = statDivs[idx];

      // Resolve final value from inline markup where possible.
      // Priority:
      // 1) data-final attribute on the number element
      // 2) an element inside the stat block with class .stat-final (e.g. <span class="stat-final">80%</span>)
      // 3) parent data-stat attribute (backwards compatibility)
      // 4) the number element's own textContent
        // Resolve final value with priority:
        // 1) explicit data attribute used by templates: data-ouc-stats-number
        // 2) data-final-raw (author-provided raw value)
        // 3) data-final (normalized numeric fallback)
        // 4) parent data-stat attribute (legacy)
        // 5) element textContent fallback
        let finalRaw = el.getAttribute('data-ouc-stats-number') || el.getAttribute('data-final-raw') || el.getAttribute('data-final') || el.dataset.final || '';
      if (!finalRaw && parent) {
        const finalNode = parent.querySelector('.stat-final');
        if (finalNode) finalRaw = finalNode.textContent.trim();
      }
      if (!finalRaw && parent) finalRaw = parent.getAttribute('data-stat') || '';
      if (!finalRaw) finalRaw = el.textContent.trim();

  // use parsed descriptor if available
  const parsed = parseStatDescriptor(finalRaw || el.dataset.finalRaw || el.textContent);
  // if markup uses <sup data-ouc-stats-super> to indicate percent, respect that
  try {
    if (!parsed.isPercent && el.querySelector && el.querySelector('sup[data-ouc-stats-super]')) parsed.isPercent = true;
  } catch (e) {}
  const end = parsed.end;
  const opts = { isPercent: parsed.isPercent, prefix: parsed.prefix, suffix: parsed.suffix, decimals: parsed.decimals };
  animateStat(el, end, 1200, opts);
    });
  }

  // Start animation when stats-callouts is in viewport
  function isInViewport(elem) {
    const rect = elem.getBoundingClientRect();
    return rect.top < window.innerHeight && rect.bottom > 0;
  }
  let started = false;
  function checkStatsStart() {
    const statsSection = document.querySelector('.stats-callouts');
    if (!started && statsSection && isInViewport(statsSection)) {
  started = true;
  runStatsParallel();
    }
  }
  window.addEventListener('scroll', checkStatsStart);
  window.addEventListener('DOMContentLoaded', checkStatsStart);
  // Immediately evaluate in case the stats section is already in view
  checkStatsStart();
});

// Featured Testimonials Interactivity (inline HTML data)
document.addEventListener('DOMContentLoaded', function () {
  const headshotEls = document.querySelectorAll('.testimonial-headshot');
  const quoteEl = document.getElementById('testimonial-quote').querySelector('.testimonial-text');
  const nameEl = document.getElementById('testimonial-name');
  const imageEl = document.getElementById('testimonial-image').querySelector('img');

  // Attempt to resolve a data source for a testimonial by index.
  // Prefer a headshot element that carries data attributes (data-quote, data-name, data-img, data-alt).
  // Fall back to the legacy .testimonial-data-item markup if present.
  function getDataItem(index) {
    const headshot = document.querySelector('.testimonial-headshot[data-index="' + index + '"]');
    if (headshot && (headshot.hasAttribute('data-quote') || headshot.hasAttribute('data-name') || headshot.hasAttribute('data-img')) ) {
      return headshot;
    }
    return document.querySelector('.testimonial-data-item[data-index="' + index + '"]');
  }

  function setTestimonial(index, skipTransition) {
    const data = getDataItem(index);
    if (!data) return;

    // small helper: escape text for safe insertion as HTML
    function escapeHtml(str) {
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    // If data is a headshot element with inline data-* attributes, read from those.
    let quote, name, img, alt;
    if (data.classList && data.classList.contains('testimonial-headshot')) {
      quote = (data.getAttribute('data-quote') || data.dataset.quote || '').trim();
      name = (data.getAttribute('data-name') || data.dataset.name || '').trim();
      img = (data.getAttribute('data-img') || data.dataset.img || data.querySelector('img')?.getAttribute('src') || '').trim();
      alt = (data.getAttribute('data-alt') || data.dataset.alt || name).trim();
    } else {
      // Legacy structure: .testimonial-data-item containing .text, .name and an <img>
      quote = data.querySelector('.text').textContent.trim();
      name = data.querySelector('.name').textContent.trim();
      img = data.querySelector('img').getAttribute('src');
      alt = data.querySelector('img').getAttribute('alt') || name;
    }

    // Preload image
    const imgPreload = new Image();
    imgPreload.src = img;
    // If caller requested no transition (first load), swap immediately.
    const $quote = $(quoteEl);
    const $name = $(nameEl);
    const $img = $(imageEl);
    if (skipTransition || typeof $ === 'undefined') {
      // immediate swap (no animation) - also support non-jQuery fallback
      if (typeof $ !== 'undefined') {
        // wrap quote with opening/closing spans
  $quote.html("<span class='sq' aria-hidden='true'>&ldquo;</span>" + escapeHtml(quote) + "<span class='eq' aria-hidden='true'>&rdquo;</span>").css({opacity: 1, transform: ''});
        $name.text(name).css({opacity: 1, transform: ''});
        $img.attr('src', img).attr('alt', alt).css({opacity: 1, transform: ''});
      } else {
        // insert as HTML with escaped content and quote wrappers
  quoteEl.innerHTML = "<span class='sq' aria-hidden='true'>&ldquo;</span>" + escapeHtml(quote) + "<span class='eq' aria-hidden='true'>&rdquo;</span>";
        nameEl.textContent = name;
        imageEl.src = img;
        imageEl.alt = alt;
      }

      // update headshot active state
      headshotEls.forEach((el) => {
        const idx = el.getAttribute('data-index');
        const active = idx === String(index) || idx === index;
        el.classList.toggle('active', active);
        el.setAttribute('aria-pressed', active);
      });

      // announce change for screen readers
      const live = document.getElementById('testimonial-live');
      if (live) live.textContent = name + ': ' + quote;
      return;
    }

    // JS-driven animation using jQuery for precise control of translateY and opacity
    const textMove = 0; // px vertical shift for quote/name
    const imgMove = 32; // px vertical shift for image
    const textDur = 200; // ms
    const imgDur = 400; // ms

    function animateWithTransform($el, fromOpacity, toOpacity, fromY, toY, duration, cb) {
      // animate a dummy property and apply transform/opacity in step
      $({progress: 0}).stop(true).animate({progress: 1}, {
        duration: duration,
        easing: 'swing',
        step(now) {
          const opacity = fromOpacity + (toOpacity - fromOpacity) * now;
          const y = fromY + (toY - fromY) * now;
          $el.css({opacity: opacity, transform: 'translateY(' + y + 'px)'});
        },
        complete() {
          if (cb) cb();
        }
      });
    }

    let outFinished = 0;
    const totalOut = 3;

    // animate out
    animateWithTransform($quote, 1, 0, 0, textMove, textDur, () => { outFinished++; if (outFinished === totalOut) doSwap(); });
    animateWithTransform($name, 1, 0, 0, textMove, textDur, () => { outFinished++; if (outFinished === totalOut) doSwap(); });
    animateWithTransform($img, 1, 0, 0, imgMove, imgDur, () => { outFinished++; if (outFinished === totalOut) doSwap(); });

    // capture any existing decorative <sup> that should remain visible
    // (testimonials don't normally use stats suffixes, but preserve legacy <sup> if present)
    let preservedSupHtml = '';
    try {
      const existingSup = quoteEl.querySelector && quoteEl.querySelector('sup[data-out-stats-attribute]');
      if (existingSup) preservedSupHtml = existingSup.outerHTML;
    } catch (e) {}

    function doSwap() {
      // swap content while elements are offscreen/transparent
      // insert quote with opening/closing quote spans (escaped)
      $quote.html("<span class='sq' aria-hidden='true'>&ldquo;</span>" + escapeHtml(quote) + "<span class='eq' aria-hidden='true'>&rdquo;</span>").css({opacity: 0, transform: 'translateY(' + textMove + 'px)'});
      $name.text(name).css({opacity: 0, transform: 'translateY(' + textMove + 'px)'});
      $img.attr('src', img).attr('alt', alt).css({opacity: 0, transform: 'translateY(' + imgMove + 'px)'});

      let inFinished = 0;
      const totalIn = 3;

      // animate the three parts into view and call finish when all complete
      animateWithTransform($quote, 0, 1, textMove, 0, textDur, () => { inFinished++; if (inFinished === totalIn) finish(); });
      animateWithTransform($name, 0, 1, textMove, 0, textDur, () => { inFinished++; if (inFinished === totalIn) finish(); });
      animateWithTransform($img, 0, 1, imgMove, 0, imgDur, () => { inFinished++; if (inFinished === totalIn) finish(); });

      function finish() {
        // update headshot active state
        headshotEls.forEach((el) => {
          const idx = el.getAttribute('data-index');
          const active = idx === String(index) || idx === index;
          el.classList.toggle('active', active);
          el.setAttribute('aria-pressed', active);
        });

        // announce change for screen readers
        const live = document.getElementById('testimonial-live');
        if (live) live.textContent = name + ': ' + quote;
      }
    }
  }

  // Ensure only the selected headshot is active (and aria-pressed reflects state)
  function setActiveHeadshot(index) {
    headshotEls.forEach((el) => {
      const idx = el.getAttribute('data-index');
      const isActive = idx === String(index) || idx === index;
      if (isActive) el.classList.add('active'); else el.classList.remove('active');
      el.setAttribute('aria-pressed', isActive);
    });
  }

  headshotEls.forEach((el) => {
    const idx = el.getAttribute('data-index');
    el.addEventListener('click', function () {
      // Immediately update active state so only the clicked thumbnail is active
      setActiveHeadshot(idx);
      setTestimonial(idx);
    });
    el.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        setActiveHeadshot(idx);
        setTestimonial(idx);
      }
    });
  });

  // init: prefer the first headshot as the source of truth; fall back to legacy .testimonial-data-item
  const firstIdx = document.querySelector('.testimonial-headshot')?.getAttribute('data-index') || document.querySelector('.testimonial-data-item')?.getAttribute('data-index') || 0;
  // Explicitly activate the first thumbnail on load, then populate testimonial content
  setActiveHeadshot(firstIdx);
  setTestimonial(firstIdx, true);
});

//Dynamically Load Events From Calendar RSS Feed (uses cal: namespaced fields when available)
document.addEventListener('DOMContentLoaded', function () {

  const container = document.querySelector('.dynamic-events');
  if (!container) return;

  // Prefer data-override-rss then data-default-rss on .event-list so feeds can be configured in HTML
  const DEFAULT_RSS = 'https://api.calendar.moderncampus.net/pubcalendar/89404b03-055e-4056-abd4-4286c809aed8/rss?url=https%3A%2F%2Fwwwdev.ecc.edu%2Fstudent-life%2Fcalendar.html&hash=true';
  const feedEl = document.querySelector('.event-list');
  let RSS_URL = DEFAULT_RSS;
  if (feedEl) {
    const override = feedEl.getAttribute('data-override-rss') || feedEl.dataset.overrideRss;
    const def = feedEl.getAttribute('data-default-rss') || feedEl.dataset.defaultRss;
    if (override) {
  RSS_URL = override;
  // console.log('Events loader: using RSS URL from .event-list data-override-rss');
    } else if (def) {
  RSS_URL = def;
  // console.log('Events loader: using RSS URL from .event-list data-default-rss');
    } else {
  // console.log('Events loader: .event-list present but no override/default attributes; using built-in default RSS URL');
    }
  } else {
  // console.log('Events loader: .event-list not found; using built-in default RSS URL');
  }
  const DEFAULT_IMG = ''; // empty => treat as "no image" and render date tile

  function stripHtml(html) {
    if (!html) return '';
    const tmp = document.createElement('div');
    tmp.innerHTML = html;
    return tmp.textContent.trim();
  }

  // Safely read a text node from an item, supporting namespaced cal: tags by escaping the colon
  function readItemText(item, selector) {
    if (!item) return '';
    const el = item.querySelector(selector);
    if (el && el.textContent) return el.textContent.trim();
    return '';
  }

  function getCal(item, tag) {
    // try namespaced cal:tag then plain tag
    return readItemText(item, 'cal\\:' + tag) || readItemText(item, tag);
  }

  function parseDateIso(iso) {
    if (!iso) return null;
    const d = new Date(iso.trim());
    return isNaN(d) ? null : d;
  }

  function formatMonthDay(date) {
    if (!date) return { month: '', day: '' };
    const months = ['JAN','FEB','MAR','APR','MAY','JUN','JUL','AUG','SEP','OCT','NOV','DEC'];
    return {
      month: months[date.getMonth()],
      day: String(date.getDate())
    };
  }

  function formatTimeRange(start, end) {
    if (!start) return '';
    try {
      const opts = { hour: 'numeric', minute: '2-digit' };
      const startStr = start.toLocaleTimeString([], opts);
      if (end) {
        // if same day and same time, show single time; otherwise show range
        const endStr = end.toLocaleTimeString([], opts);
        if (startStr === endStr) return startStr;
        return startStr + ' - ' + endStr;
      }
      return startStr;
    } catch (e) {
      return '';
    }
  }

  // ordinal suffix for day numbers (1st, 2nd, 3rd, 4th...)
  function ordinalSuffix(n) {
    const s = ["th","st","nd","rd"], v = n % 100;
    return n + (s[(v-20)%10] || s[v] || s[0]);
  }

  // format prefix like: Mon, Sep 17th, 2025,
  function formatDatePrefix(date) {
    if (!date) return '';
    try {
      const weekday = date.toLocaleDateString([], { weekday: 'short' });
      const month = date.toLocaleDateString([], { month: 'short' });
      const day = ordinalSuffix(date.getDate());
      const year = date.getFullYear();
      return weekday + ', ' + month + ' ' + day + ', ' + year + ',';
    } catch (e) {
      return '';
    }
  }

  // truncate to maxLen chars, do not break words, append ellipsis if truncated 
  function truncateText(text, maxLen) {
    if (!text) return '';
    const t = text.trim();
    if (t.length <= maxLen) return t;
    // find last whitespace before maxLen
    let sub = t.slice(0, maxLen + 1);
    const lastSpace = sub.lastIndexOf(' ');
    if (lastSpace > 0) sub = sub.slice(0, lastSpace);
    else sub = sub.slice(0, maxLen);
    return sub.trim() + '…';
  }

  // debug: starting loader
  // console.log('Events loader: starting. RSS_URL=', RSS_URL);
  fetch(RSS_URL)
    .then(res => {
  // console.log('Events loader: fetch completed. status=', res.status, res.statusText);
      if (!res.ok) throw new Error('Network response was not ok');
      return res.text();
    })
    .then(xmlText => {
  // console.log('Events loader: parsing XML');
      const doc = new DOMParser().parseFromString(xmlText, 'application/xml');
      // Gather all items and apply optional client-side filters (data-featured, data-calendar)
      let allItems = Array.from(doc.querySelectorAll('item'));

      // Read on-element data attributes from the container
      const featuredAttr = container.getAttribute('data-featured') || container.dataset.featured || '';
  const calendarAttr = container.getAttribute('data-calendar') || container.dataset.calendar || '';
  const featuredOnly = String(featuredAttr).toLowerCase() === 'true' || String(featuredAttr) === '1';
  // case-insensitive calendar matching; if explicitly set to 'false', disable calendar filtering
  const rawCalendar = String(calendarAttr || '').trim();
  const calendarFilter = rawCalendar.toLowerCase() === 'false' || rawCalendar === '' ? '' : rawCalendar.toLowerCase();

      // Apply filters using helper getCal (supports cal: namespace)
      if (featuredOnly) {
        allItems = allItems.filter(item => {
          const v = (getCal(item, 'featured') || '').trim().toLowerCase();
          return v === 'true' || v === '1' || v === 'yes';
        });
  // console.log('Events loader: filtering to featured items only; remaining=', allItems.length);
      }
      if (calendarFilter) {
        allItems = allItems.filter(item => {
          const v = (getCal(item, 'calendar') || '').trim().toLowerCase();
          return v === calendarFilter;
        });
  // console.log('Events loader: filtering to calendar="' + calendarFilter + '"; remaining=', allItems.length);
      }

      // limit to up to 3 items for display
      const items = allItems.slice(0, 3);
  // console.log('Events loader: found', allItems.length, 'matching items (showing up to', items.length, ')');

  // If there are no matching items, show an accessible 'No Upcoming Events' message
  if (!items.length) {
    try {
      container.innerHTML = '<div class="no-upcoming-events" role="status" aria-live="polite">No Upcoming Events</div>';
      // ensure events-waiting class removed if present
      const eventList = document.querySelector('.event-list');
      if (eventList) eventList.classList.remove('events-waiting');
    } catch (e) {
      console.warn('Events loader: failed to render no-results message', e);
    }
    return;
  }

  // clear container before rendering
  container.innerHTML = '';
  // console.log('Events loader: cleared container');
  // mark container as a list for assistive tech
  try { container.setAttribute('role', 'list'); } catch (e) {}

  items.forEach((item, i) => {
    // per-item debug info
    try {
      const dbgTitle = stripHtml(readItemText(item, 'title')) || '[no title]';
      const dbgStart = getCal(item, 'start') || getCal(item, 'startDate') || readItemText(item, 'pubDate') || '';
      const dbgImg = getCal(item, 'image') || (item.querySelector('enclosure') && item.querySelector('enclosure').getAttribute('url')) || '';
      const dbgTicket = getCal(item, 'ticketUrl') || '';
  // console.log('Events loader: item', i, { title: dbgTitle, start: dbgStart, img: dbgImg, ticket: dbgTicket });
    } catch (e) {
  // console.log('Events loader: item debug failed', e);
    }
        const title = stripHtml(readItemText(item, 'title')) || 'Untitled';
        const link = readItemText(item, 'link') || '#';
        const rawDesc = item.querySelector('description')?.textContent || '';
        const desc = stripHtml(rawDesc);

        // Prefer cal:image then enclosure/media as fallback
        const calImage = getCal(item, 'image');
        const enclosure = item.querySelector('enclosure');
        const media = item.querySelector('media\\:content, media\\:thumbnail, media\\:group');
        const imgUrl = (calImage && calImage.trim()) ||
                       (enclosure && enclosure.getAttribute('url')) ||
                       (media && (media.getAttribute('url') || media.querySelector('url')?.textContent)) ||
                       '';
        const imgAlt = getCal(item, 'imageAltText') || title;

        // Dates and times (cal:start / cal:end are ISO 8601)
        const startStr = getCal(item, 'start') || getCal(item, 'startDate') || readItemText(item, 'pubDate');
        const endStr = getCal(item, 'end') || getCal(item, 'endDate');
        const start = parseDateIso(startStr);
        const end = parseDateIso(endStr);

        const { month, day } = formatMonthDay(start);
        const timeRange = formatTimeRange(start, end);

        const location = getCal(item, 'location') || '';
        const locationRoom = getCal(item, 'locationRoom') || '';
        const ticketUrl = getCal(item, 'ticketUrl') || '';
        const ticketLabel = getCal(item, 'ticketButtonLabel') || '';

  const eventItem = document.createElement('div');
  eventItem.className = 'event-item';
  // accessibility: treat each event as a listitem and reference the title
  eventItem.setAttribute('role', 'listitem');

  const imgWrap = document.createElement('div');
  imgWrap.className = 'event-img';

        if (imgUrl && imgUrl !== DEFAULT_IMG) {
          const img = document.createElement('img');
          img.src = imgUrl;
          img.alt = imgAlt || title;
          imgWrap.appendChild(img);
        } else {
          // No image -> render date tile inside .event-img
          const dateDiv = document.createElement('div');
          dateDiv.className = 'event-date';
          const monthSpan = document.createElement('span');
          monthSpan.className = 'event-date__month';
          monthSpan.textContent = month;
          const daySpan = document.createElement('span');
          daySpan.className = 'event-date__day';
          daySpan.textContent = day;
          dateDiv.appendChild(monthSpan);
          dateDiv.appendChild(daySpan);

          // Provide a screen-reader-only readable date string
          const sr = document.createElement('span');
          sr.className = 'event-date__sr';
          // visually-hidden technique - inline style to be robust even if CSS not present
          sr.setAttribute('style', 'position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0;');
          sr.textContent = start ? start.toLocaleDateString() : (month + ' ' + day);
          dateDiv.appendChild(sr);

          imgWrap.appendChild(dateDiv);
        }

        const content = document.createElement('div');
        content.className = 'event-content';

  const h3 = document.createElement('h3');
  const titleId = 'event-title-' + i;
  h3.id = titleId;
  h3.textContent = title;

        // meta info: date/time (location intentionally omitted per requirements)
        const meta = document.createElement('div');
        meta.className = 'event-meta';
        if (start || timeRange) {
          const timeEl = document.createElement('time');
          if (start) timeEl.setAttribute('datetime', start.toISOString());
          timeEl.className = 'event-meta__time';
          const prefix = start ? formatDatePrefix(start) : '';
          timeEl.textContent = (prefix ? prefix + ' ' : '') + (timeRange || '');
          meta.appendChild(timeEl);
        }

        const p = document.createElement('p');
        // swap: show location (location + room) where description used to be; fall back to description
        const locText = (location ? location : '') + (locationRoom ? (location ? ', ' + locationRoom : locationRoom) : '');
        const displayText = locText || desc || '';
        if (displayText) {
          const descId = 'event-desc-' + i;
          p.id = descId;
          p.textContent = truncateText(displayText, 60);
          // reference description/location from the event item for assistive tech
          try { eventItem.setAttribute('aria-describedby', descId); } catch (e) {}
        }

        // ensure the event-item is labelled by the heading
        try { eventItem.setAttribute('aria-labelledby', titleId); } catch (e) {}

        const actions = document.createElement('div');
        actions.className = 'event-actions';

  const a = document.createElement('a');
  a.className = 'cta cta--link';
  a.href = link;
  a.textContent = 'Learn More';
  // make link label explicit for screen reader (includes event title)
  a.setAttribute('aria-label', 'Learn more about ' + title);
  actions.appendChild(a);

        if (ticketUrl) {
          const ticket = document.createElement('a');
          ticket.className = 'cta cta--link';
          ticket.href = ticketUrl;
          ticket.target = '_blank';
          ticket.rel = 'noopener noreferrer';
          ticket.textContent = ticketLabel || 'Tickets';
          ticket.setAttribute('aria-label', (ticketLabel || 'Tickets') + ' for ' + title);
          actions.appendChild(ticket);
        }

        content.appendChild(h3);
        if (meta.childNodes.length) content.appendChild(meta);
        if (desc) content.appendChild(p);
        content.appendChild(actions);

        eventItem.appendChild(imgWrap);
        eventItem.appendChild(content);

        container.appendChild(eventItem);
      });

        // If we have fewer than 3 results, hide any placeholder/blank event entries
        if (items.length < 3) {
          try {
            const placeholders = Array.from(document.querySelectorAll('.event-item--placeholder, .event-item.placeholder, .event-item.is-placeholder, .event-item.blank, .is-empty'));
            placeholders.forEach(function (p) {
              // try to hide only those within the events area or obvious placeholders
              if (container.contains(p) || p.closest && p.closest('.dynamic-events') || p.closest('.events') || p.classList.contains('is-empty')) {
                p.style.display = 'none';
              }
            });
          } catch (e) {
            console.warn('Events loader: hiding placeholders failed', e);
          }
        }

      // remove events-waiting class from .event-list once loaded
      try {
        const eventList = document.querySelector('.event-list');
        if (eventList) {
          eventList.classList.remove('events-waiting');
          // console.log('Events loader: removed events-waiting class from .event-list');
        }
      } catch (e) {
        // console.log('Events loader: failed to remove events-waiting class', e);
      }
    })
    .catch(err => {
      console.error('Failed to load events RSS:', err);
    });
});

/* Tertiary nav: mobile tap-to-open behavior (moved from inline in internal.php)
   Accessibility enhancements: aria-expanded, aria-controls, aria-hidden, keyboard support
*/
document.addEventListener('DOMContentLoaded', function () {
  function initTertiaryNav() {
    var MOBILE_BREAK = 599;
    var nav = document.querySelector('.nav-tertiary');
    if (!nav) return;

    function closeAll() {
      // restore any moved submenus and close open items
      nav.querySelectorAll('li.is-open').forEach(function (li) {
        li.classList.remove('is-open');
        var a = li.querySelector(':scope > a');
        var submenu = li.querySelector(':scope > ul');
        if (a) a.setAttribute('aria-expanded', 'false');
        if (submenu) submenu.setAttribute('aria-hidden', 'true');
        // if submenu was moved to body, restore it
        if (submenu && submenu.__tertiary_moved) {
          restoreSubmenu(submenu);
        }
      });
    }

    // map moved submenu -> original insertion point
    var movedMap = new WeakMap();

    function moveSubmenuToBody(submenu, anchor) {
      if (!submenu || submenu.__tertiary_moved) return;
      try {
        var rect = anchor.getBoundingClientRect();
        var docWidth = document.documentElement.clientWidth || window.innerWidth;
        // store original parent/nextSibling
        movedMap.set(submenu, { parent: submenu.parentElement, nextSibling: submenu.nextElementSibling });
        document.body.appendChild(submenu);
        submenu.__tertiary_moved = true;
        // apply fixed positioning to avoid overflow clipping inside the scrolling container
        submenu.style.position = 'fixed';
        submenu.style.top = (Math.round(rect.bottom) + 6) + 'px';
        // prefer aligning left to the anchor but keep within viewport padding
        var left = Math.max(8, Math.round(rect.left));
        submenu.style.left = left + 'px';
        submenu.style.right = 'auto';
        submenu.style.zIndex = '9999';
        submenu.style.maxWidth = Math.min(docWidth - 16, 400) + 'px';
        submenu.style.boxSizing = 'border-box';
        submenu.style.overflow = 'auto';
        submenu.style.maxHeight = '60vh';
        // nudge if it overflows right edge
        var sb = submenu.getBoundingClientRect();
        if (sb.right > docWidth - 8) {
          var shift = sb.right - (docWidth - 8);
          submenu.style.left = Math.max(8, left - shift) + 'px';
        }
      } catch (e) {
        // fail gracefully
        console.warn('moveSubmenuToBody failed', e);
      }
    }

    function restoreSubmenu(submenu) {
      if (!submenu || !submenu.__tertiary_moved) return;
      var info = movedMap.get(submenu) || {};
      try {
        if (info.parent) {
          if (info.nextSibling && info.nextSibling.parentNode === info.parent) {
            info.parent.insertBefore(submenu, info.nextSibling);
          } else {
            info.parent.appendChild(submenu);
          }
        }
      } catch (e) {
        console.warn('restoreSubmenu failed', e);
      }
      // cleanup
      submenu.__tertiary_moved = false;
      movedMap.delete(submenu);
      submenu.style.position = '';
      submenu.style.top = '';
      submenu.style.left = '';
      submenu.style.right = '';
      submenu.style.zIndex = '';
      submenu.style.maxWidth = '';
      submenu.style.boxSizing = '';
      submenu.style.overflow = '';
      submenu.style.maxHeight = '';
    }

    // prepare anchors with submenus
    var anchors = Array.from(nav.querySelectorAll('ul > li > a'));
    anchors.forEach(function (anchor, idx) {
      var parent = anchor.parentElement;
      var submenu = parent.querySelector(':scope > ul');
      if (!submenu) return;

      // ensure id on submenu for aria-controls
      if (!submenu.id) submenu.id = 'nav-tertiary-sub-' + idx;
      anchor.setAttribute('aria-haspopup', 'true');
      anchor.setAttribute('aria-controls', submenu.id);
      anchor.setAttribute('aria-expanded', parent.classList.contains('is-open') ? 'true' : 'false');
      submenu.setAttribute('aria-hidden', parent.classList.contains('is-open') ? 'false' : 'true');

      // For accessibility, mark anchors that have submenus. We will NOT attach
      // mobile tap-to-open handlers: on small screens submenus are disabled and
      // the top-level nav remains horizontally scrollable.
      anchor.setAttribute('aria-haspopup', 'true');
      anchor.setAttribute('aria-controls', submenu.id);
      anchor.setAttribute('aria-expanded', parent.classList.contains('is-open') ? 'true' : 'false');
      submenu.setAttribute('aria-hidden', parent.classList.contains('is-open') ? 'false' : 'true');

      // If any submenu was moved previously (from earlier behavior), restore it so
      // the DOM is consistent now.
      if (submenu.__tertiary_moved) restoreSubmenu(submenu);
    });

    // close on outside tap
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.nav-tertiary')) {
        closeAll();
        // restore any moved submenus
        document.querySelectorAll('.nav-tertiary ul ul').forEach(function (sub) {
          if (sub.__tertiary_moved) restoreSubmenu(sub);
        });
      }
    });

    // when resizing to desktop, ensure menus are closed and ARIA reset
    window.addEventListener('resize', function () {
      if (window.innerWidth > MOBILE_BREAK) {
        closeAll();
        anchors.forEach(function (anchor) {
          var li = anchor.parentElement;
          var sub = li.querySelector(':scope > ul');
          anchor.setAttribute('aria-expanded', 'false');
          if (sub) sub.setAttribute('aria-hidden', 'true');
        });
        // restore any moved submenus
        document.querySelectorAll('.nav-tertiary ul ul').forEach(function (sub) {
          if (sub.__tertiary_moved) restoreSubmenu(sub);
        });
      }
    });
  }
  initTertiaryNav();
});

/* Tabs / Accordion (campus-tabs)
   Behavior:
   - Desktop (>767px): horizontal tab buttons; a single active panel is shown in the panels area.
   - Mobile (<=767px): buttons stack vertically and panels are moved inline directly after their button; panels open/close with smooth height transitions.
*/
(function () {
  function initCampusTabsInstance(root) {
    if (!root) return;
    const buttons = Array.from(root.querySelectorAll('.tab-button'));
    const panelsContainer = root.querySelector('.tabs-modern__panels');
    // collect panels from the panelsContainer initially (they may be moved later)
    let panels = panelsContainer ? Array.from(panelsContainer.querySelectorAll('.tab-panel')) : [];

  const mq = window.matchMedia('(max-width: 767px)');
  // no active panel by default
  let activeIndex = null;

    function getPanelByIndex(idx) {
      // refresh panel list within this instance in case DOM moved
      panels = Array.from(root.querySelectorAll('.tab-panel'));
      // prefer data-index within this instance
      return panels.find(p => p.dataset.index === String(idx));
    }

    // Smooth open/close using max-height; compute content height
    function openPanel(panel) {
      if (!panel) return;
  // try { console.debug('[tabs] openPanel()', panel, { display: panel.style.display, ariaHidden: panel.getAttribute('aria-hidden'), dataActive: panel.getAttribute('data-active') }); } catch (e) {}
      // clear any pending close fallback for this panel to avoid races
      try {
        if (panel.__tab_close_fallback) {
          clearTimeout(panel.__tab_close_fallback);
    // try { console.debug('[tabs] cleared pending close fallback for', panel); } catch (e) {}
        }
        panel.__tab_close_fallback = null;
      } catch (e) {}
      panel.style.display = 'block';
      // ensure inner content's height
      const inner = panel.querySelector('.tab-panel__inner') || panel;
      // clear previously set maxHeight to measure natural height
      panel.style.maxHeight = '';
      const height = inner.scrollHeight;
      // add small buffer to prevent clipping of the last line (fonts/images maybe late)
      const buffer = 16; // px
      // force reflow then set maxHeight for transition
      void panel.offsetHeight;
      panel.style.maxHeight = (height + buffer) + 'px';
      panel.setAttribute('data-active', 'true');
      panel.setAttribute('aria-hidden', 'false');
    }

    function closePanel(panel) {
      if (!panel) return;
      // DEBUG: trace closePanel calls (remove these logs once issue is diagnosed)
  // try { console.debug('[tabs] closePanel()', panel, { display: panel.style.display, ariaHidden: panel.getAttribute('aria-hidden'), dataActive: panel.getAttribute('data-active') }); } catch (e) {}
      // set maxHeight to current height then to 0 to animate
      const inner = panel.querySelector('.tab-panel__inner') || panel;
      const height = inner.scrollHeight;
      panel.style.maxHeight = height + 'px';
      // force reflow
      void panel.offsetHeight;
      panel.style.maxHeight = '0px';
      panel.removeAttribute('data-active');
      panel.setAttribute('aria-hidden', 'true');
      // after transition hide completely to avoid tabbing into it
      const onEnd = function (e) {
        // only act on the max-height transition (some browsers fire multiple events)
        
        if (e.propertyName === 'max-height') {
          // hide unconditionally to ensure inline display doesn't persist
          panel.style.display = 'none';
        }
        setTimeout(function(){panel.style.display = 'none';},150);
        try { panel.removeEventListener('transitionend', onEnd); } catch (err) {}
        try { clearTimeout(fallbackTimer); } catch (err) {}
        try { panel.__tab_close_fallback = null; } catch (err) {}
  // try { console.debug('[tabs] closePanel.onEnd fired for', panel); } catch (e) {}
      };
      panel.addEventListener('transitionend', onEnd);

      // Safety fallback: some conditions (display/overflow/layout quirks, interrupted transitions,
      // or device/browser behaviors) can prevent transitionend from firing. Compute the CSS
      // transition duration for this element and ensure we hide it after that time.
      let fallbackTimer = null;
      try {
        const cs = window.getComputedStyle(panel);
        const durations = (cs.transitionDuration || '').split(',').map(s => parseFloat(s) || 0);
        const delays = (cs.transitionDelay || '').split(',').map(s => parseFloat(s) || 0);
        const maxDur = durations.length ? Math.max(...durations) : 0;
        const maxDelay = delays.length ? Math.max(...delays) : 0;
  // try { console.debug('[tabs] computed transition for', panel, { transitionDuration: cs.transitionDuration, transitionDelay: cs.transitionDelay, maxDur, maxDelay }); } catch (e) {}
        // convert to ms and add a small cushion
        const ms = Math.ceil((maxDur + maxDelay) * 1000) + 80;
        fallbackTimer = setTimeout(() => {
          // force-hide regardless of attributes to avoid lingering inline styles
          panel.style.display = 'none';
          try { panel.removeEventListener('transitionend', onEnd); } catch (err) {}
    // try { console.debug('[tabs] fallback hide triggered for', panel); } catch (e) {}
          try { panel.__tab_close_fallback = null; } catch (err) {}
        }, Math.max(ms, 200));
        try { panel.__tab_close_fallback = fallbackTimer; } catch (err) {}
        // If transitions are effectively disabled (duration 0), hide immediately
        if (maxDur === 0) {
          try { clearTimeout(fallbackTimer); } catch (e) {}
          try { panel.removeEventListener('transitionend', onEnd); } catch (e) {}
          if (panel.getAttribute('data-active') !== 'true') panel.style.display = 'none';
          return;
        }
      } catch (err) {
        // if anything goes wrong computing styles, still ensure we hide after a safe default
        fallbackTimer = setTimeout(() => {
          if (panel.getAttribute('data-active') !== 'true') panel.style.display = 'none';
          try { panel.removeEventListener('transitionend', onEnd); } catch (e) {}
        }, 500);
      }
    }

    function collapseAllMobile() {
      panels = Array.from(document.querySelectorAll('.tab-panel'));
      panels.forEach(p => closePanel(p));
      buttons.forEach(b => b.setAttribute('aria-expanded', 'false'));
    }

    // Wait for a set of panels to finish their close transition (max-height) before proceeding.
    function waitForPanelsToClose(panelsToWatch, timeoutMs) {
      return new Promise((resolve) => {
        if (!panelsToWatch || !panelsToWatch.length) return resolve();
        // if no explicit timeout provided, compute one from the panels' CSS transition durations
        if (typeof timeoutMs === 'undefined' || timeoutMs === null) {
          // per-instance override via data-wait-ms on root
          const rootOverride = root.getAttribute('data-wait-ms');
          if (rootOverride) timeoutMs = Number(rootOverride) || 500;
          else {
            // compute max transition time among panels (duration + delay)
            let maxMs = 0;
            panelsToWatch.forEach(p => {
              try {
                const cs = window.getComputedStyle(p);
                const durations = cs.transitionDuration.split(',').map(s => parseFloat(s) || 0);
                const delays = cs.transitionDelay.split(',').map(s => parseFloat(s) || 0);
                // durations/delays are in seconds, convert to ms and add
                const localMax = Math.max(...durations) * 1000 + Math.max(...delays) * 1000;
                if (localMax > maxMs) maxMs = localMax;
              } catch (e) {
                /* ignore */
              }
            });
            // add small cushion (150ms)
            timeoutMs = Math.max(250, Math.ceil(maxMs + 150));
          }
        }
        let remaining = panelsToWatch.length;
        const timers = [];
        panelsToWatch.forEach((p) => {
          // If already hidden / not active, consider it closed
          const isActive = p.getAttribute('data-active') === 'true' || p.getAttribute('aria-hidden') === 'false' || p.style.display !== 'none';
          if (!isActive) {
            remaining -= 1;
            return;
          }
          const onEnd = function (e) {
            if (e.propertyName === 'max-height') {
              p.removeEventListener('transitionend', onEnd);
              remaining -= 1;
              if (remaining <= 0) {
                timers.forEach(t => clearTimeout(t));
                resolve();
              }
            }
          };
          p.addEventListener('transitionend', onEnd);
          // safety timeout in case transitionend doesn't fire
          const t = setTimeout(() => {
            try { p.removeEventListener('transitionend', onEnd); } catch (e) {}
            remaining -= 1;
            if (remaining <= 0) resolve();
          }, timeoutMs);
          timers.push(t);
        });
        if (remaining <= 0) resolve();
      });
    }

    function hideAllDesktop() {
      panels = Array.from(root.querySelectorAll('.tab-panel'));
      // ensure all panels are in the panelsContainer and hidden
      panels.forEach(p => {
        if (p.parentNode !== panelsContainer) panelsContainer.appendChild(p);
        p.style.display = 'none';
        p.style.maxHeight = '0px';
        p.removeAttribute('data-active');
        p.setAttribute('aria-hidden', 'true');
      });
      buttons.forEach(b => b.setAttribute('aria-expanded', 'false'));
    }

    function showDesktopActive(idx) {
      // scope panels to this instance only
      panels = Array.from(root.querySelectorAll('.tab-panel'));
      // ensure panels live inside this instance's panelsContainer
      panels.forEach(p => { if (p.parentNode !== panelsContainer) panelsContainer.appendChild(p); });

      // Determine panels that are currently open/visible (could be zero)
      const currentlyOpen = panels.filter(p => p.getAttribute('data-active') === 'true' || p.getAttribute('aria-hidden') === 'false' || p.style.display !== 'none');

      // If there are panels open, close them with animation, wait for close transitions, then open the target.
      const targetPanel = panels.find(p => p.dataset.index === String(idx));
      if (!targetPanel) {
        // no panel found — just update button state
        buttons.forEach(b => b.setAttribute('aria-expanded', b.dataset.index === String(idx) ? 'true' : 'false'));
        return;
      }

      // If the target panel is already the only open panel, do nothing to avoid re-opening
      if (currentlyOpen.length === 1 && currentlyOpen[0] === targetPanel) {
        // still ensure button states are correct
        buttons.forEach(b => b.setAttribute('aria-expanded', b.dataset.index === String(idx) ? 'true' : 'false'));
        return;
      }

      // If nothing is open, just open the targetPanel
      if (!currentlyOpen.length) {
        // directly open target
        openPanel(targetPanel);
        // ensure its display state/aria are correct
        targetPanel.setAttribute('aria-hidden', 'false');
        buttons.forEach(b => b.setAttribute('aria-expanded', b.dataset.index === String(idx) ? 'true' : 'false'));
        return;
      }

      // Close all currently open panels (animated)
      currentlyOpen.forEach(p => closePanel(p));
      // Wait for them to finish closing, then open the target panel
      waitForPanelsToClose(currentlyOpen).then(() => {
        // small next-tick to ensure layout is stable
        requestAnimationFrame(() => {
          openPanel(targetPanel);
          // update ARIA and button states
          targetPanel.setAttribute('aria-hidden', 'false');
          buttons.forEach(b => b.setAttribute('aria-expanded', b.dataset.index === String(idx) ? 'true' : 'false'));
        });
      });
    }

    function handleClick(btn) {
      const idx = Number(btn.dataset.index);
      const panel = getPanelByIndex(idx);
      if (mq.matches) {
        // mobile: toggle inline
        const isExpanded = btn.getAttribute('aria-expanded') === 'true';
        if (isExpanded) {
          btn.setAttribute('aria-expanded', 'false');
          closePanel(panel);
        } else {
          // Snap-close other open panels immediately (no transition), so layout stabilizes for scroll.
          const allPanels = Array.from(root.querySelectorAll('.tab-panel'));
          const panelsToClose = allPanels.filter(p => p !== panel && (p.getAttribute('data-active') === 'true' || p.getAttribute('aria-hidden') === 'false' || p.style.display !== 'none'));

          panelsToClose.forEach(p => {
            try {
              // temporarily disable transition
              const prevTransition = p.style.transition;
              p.style.transition = 'none';
              // snap closed
              p.style.maxHeight = '0px';
              p.style.display = 'none';
              p.removeAttribute('data-active');
              p.setAttribute('aria-hidden', 'true');
              // restore transition shortly after to allow future animated opens
              setTimeout(() => { try { p.style.transition = prevTransition || ''; } catch (e) {} }, 50);
            } catch (e) {}
          });
          // mark other buttons as collapsed
          buttons.forEach(b => { if (b !== btn) b.setAttribute('aria-expanded', 'false'); });

          // move panel directly after button
          if (btn.nextElementSibling !== panel) btn.parentNode.insertBefore(panel, btn.nextElementSibling);

          // Scroll button to top (accounting for header) first, then open target panel with animation
          try {
            const header = document.querySelector('header.header') || document.querySelector('header') || document.querySelector('.site-header') || document.querySelector('.masthead');
            const headerHeight = header ? header.offsetHeight : (document.body.classList.contains('sticky-header') ? 56 : 0);
            // allow a frame for DOM changes to settle, then scroll
            requestAnimationFrame(() => {
              const rect = btn.getBoundingClientRect();
              const absoluteTop = window.scrollY + rect.top;
              const offsetTop = Math.max(0, absoluteTop - headerHeight - 8);
              window.scrollTo({ top: offsetTop, behavior: 'smooth' });
              // open the panel after scroll initiated so the open animation is visible
              // small timeout to give the scroll a head start
              setTimeout(() => {
                btn.setAttribute('aria-expanded', 'true');
                openPanel(panel);
              }, 120);
            });
          } catch (e) {
            // fallback: just open
            btn.setAttribute('aria-expanded', 'true');
            openPanel(panel);
          }
        }
        return;
      }
      // desktop: make this the single active panel
      activeIndex = idx;
      showDesktopActive(activeIndex);
    }

    // attach handlers
    buttons.forEach(btn => {
      btn.addEventListener('click', function (e) { handleClick(btn); });
      btn.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleClick(btn); } });
    });

    // handle breakpoint changes
    function onMqChange() {
      if (mq.matches) {
        // switch to mobile: collapse all panels
        collapseAllMobile();
      } else {
        // switch to desktop: show activeIndex
        showDesktopActive(activeIndex);
      }
    }

  // initialize: start with no panel displayed
  if (mq.matches) collapseAllMobile(); else hideAllDesktop();
    mq.addEventListener('change', onMqChange);
    window.addEventListener('resize', function () { onMqChange(); });
  }

  // find all .tabs instances and initialize each
  function initAllCampusTabs() {
    const roots = Array.from(document.querySelectorAll('.tabs-modern'));
    roots.forEach(r => initCampusTabsInstance(r));
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAllCampusTabs); else initAllCampusTabs();
})();

  // Ensure #nav-search gains focus after the search dialog is opened (handles onclick="window.dialogsearch.showModal();")
  document.addEventListener('DOMContentLoaded', function () {
    const targetSelector = '#nav-search';
    const dialogIds = ['dialogsearch', 'search-dialog', 'dialog-search'];

    function findDialog() {
      // prefer the explicit dialog id used on the site
      const preferred = document.getElementById('dialogsearch');
      if (preferred) return preferred;

      // try common global reference
      if (window.dialogsearch) return window.dialogsearch;

      // try other common ids and finally fall back to the first dialog
      for (let id of dialogIds) {
        const d = document.getElementById(id);
        if (d) return d;
      }
      return document.querySelector('dialog');
    }

    function focusNavSearch() {
      const el = document.querySelector(targetSelector);
      if (!el) return;
      try {
        el.focus({ preventScroll: true });
      } catch (e) {
        // older browsers
        el.focus();
      }
    }

    // Attach click listeners to elements that open the dialog. The page may use an
    // inline onclick="window.dialogsearch.showModal();" so we don't call showModal
    // ourselves — we just wait for the dialog to open and then focus the input.
  const triggers = Array.from(document.querySelectorAll('.search-toggle, [data-toggle="search"]'));
  if (!triggers.length) return;

    triggers.forEach(btn => {
      btn.addEventListener('click', function () {
        // After click, the inline onclick may run showModal(); wait for dialog.open
        // with a short polling loop and then focus the target.
        const dialogRef = findDialog();
        let attempts = 0;
        const maxAttempts = 12; // ~600ms (12 * 50ms)
        const iv = setInterval(() => {
          attempts++;
          if (dialogRef && dialogRef.open) {
            focusNavSearch();
            clearInterval(iv);
            return;
          }
          if (attempts >= maxAttempts) {
            // give one final shot regardless
            focusNavSearch();
            clearInterval(iv);
          }
        }, 50);
        // also try on next frame for faster UX
        requestAnimationFrame(() => { if (dialogRef && dialogRef.open) focusNavSearch(); });
      });
    });

    // Backdrop click-to-close: attach a click handler to the dialog itself that
    // closes it when the backdrop is clicked (i.e., event.target === dialog).
    (function attachBackdropClose() {
      const preferred = document.getElementById('dialogsearch');
      const attach = (dlg) => {
        if (!dlg || dlg.dataset.backdropCloseAttached) return;
        dlg.addEventListener('click', function (ev) {
          try {
            if (ev.target === dlg) {
              if (typeof dlg.close === 'function') dlg.close(); else dlg.removeAttribute('open');
            }
          } catch (e) {
            // ignore
          }
        });
        try { dlg.dataset.backdropCloseAttached = '1'; } catch (e) {}
      };
      if (preferred) attach(preferred); else document.querySelectorAll('dialog').forEach(attach);
    })();
  });

  const hideChatHandle = (function () {
  // helper to compute threshold (50vh)
  const threshold = () => window.innerHeight * 0.5;

  let ticking = false;
  let lastState = null;

  function check() {
    const scrolled = window.scrollY || window.pageYOffset || 0;
    const isPast = scrolled >= threshold();
    if (isPast !== lastState) {
      document.body.classList.toggle('hide-chat', isPast);
      lastState = isPast;
    }
  }

  function onScroll() {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(() => {
        check();
        ticking = false;
      });
    }
  }

  function onResize() {
    // Re-evaluate threshold when viewport height changes
    check();
  }

  // initial evaluation
  check();

  // attach listeners
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onResize);

  // return a handle so the caller can remove listeners / cleanup
  return {
    destroy() {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onResize);
      document.body.classList.remove('hide-chat');
    }
  };

})();